import React from "react";
import Button from "@mui/material/Button";

const AddDiscountButton = ({
  setOpenAddDebtModal,
  disabled,
  debtId,
  amount,
  setDebtToDelete,
}) => {
  const handleButtonClick = () => {
    setDebtToDelete({ amount: amount, id: debtId });
    setOpenAddDebtModal(true);
  };

  return (
    <>
      <div style={{ paddingTop: "20px", textAlign: "center" }}>
        <Button
          disabled={disabled}
          variant="contained"
          color="primary"
          onClick={handleButtonClick}
          style={{ margin: "8px auto" }}
        >
          Προσθήκη Έκπτωσης
        </Button>
      </div>
    </>
  );
};

export default AddDiscountButton;
